import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { plainToClass } from 'class-transformer';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { IntegrationModel } from 'app/shared/models/integration.model';

/**
* Service for the Integration management.
*/
@Injectable()
export class IntegrationService {
    constructor(private requestService: ObservableRequestService) { }

    getIntegrationsList(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.INTEGRATIONS_ENDPOINT)
            .map(response => {
                return plainToClass(IntegrationModel, response.arrResult as Object);
            });
    }

    saveIntegration(body: Object): Observable<any> {
        return this.requestService
            .postRequest(ConstantsService.INTEGRATIONS_ENDPOINT,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };

    deleteIntegration(integrationId: number): Observable<any> {
        return this.requestService.deleteRequest(ConstantsService.INTEGRATIONS_ENDPOINT,
            this.requestService.serialize({integrationId : integrationId}),
            this.requestService.getFormEncodedContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/integrations/integration.service.ts